// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MediumIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Medium/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22 2H2v20h20V2ZM6.66 14.607V9.04a.463.463 0 0 0-.176-.412L5.176 7.212V7h4.06l3.136 6.19L15.132 7H19v.212l-1.118.964a.28.28 0 0 0-.124.282v7.084a.28.28 0 0 0 .124.282l1.092.964V17h-5.49v-.212l1.13-.987c.111-.1.111-.13.111-.283V9.793l-3.143 7.185h-.425l-3.66-7.185v4.815a.624.624 0 0 0 .202.553l1.47 1.605v.212H5v-.212l1.47-1.605a.6.6 0 0 0 .19-.553Z",
  clipRule: "evenodd"
}));
export default MediumIcon;